// Ninocat Link (port forwarding) API helpers — see internal/api/link.go.
import { api } from './api.js';

export const linkStatus = () => api.get('/api/link/status');
export const revokeLink = () => api.delete('/api/link/token');
export const linkDownloadUrl = (arch = 'amd64') => `/api/link/download?arch=${encodeURIComponent(arch)}`;
